export default "__VITE_ASSET__CxiD4dRi__"